import { selectorFamily } from 'recoil';
import { type RangeDebugResponse } from 'venn-api';
import { createRangeDebugKey, rangeDebugQueryFn, VennQueryClient } from 'venn-utils';
import { originalAnalysisSubjectQuery } from '../configuration/subjects';

import { type Subject, toSubjectOnly } from '../types';

/**
 * Wrapper around rangeDebugQueryImpl.
 * It ensures that fees are not included in the request
 * as they don't affect range debug
 */
export const rangeDebugQuery = selectorFamily<RangeDebugResponse | null, Subject | undefined>({
  key: 'rangeDebugQuery',
  get:
    (subject) =>
    ({ get }) => {
      if (!subject) {
        return null;
      }
      return get(rangeDebugQueryImpl(toSubjectOnly(subject)));
    },
});

const rangeDebugQueryImpl = selectorFamily<RangeDebugResponse | null, Subject>({
  key: 'rangeDebugQueryImpl',
  get:
    (subject) =>
    async ({ get }) => {
      const analysisSubject = get(originalAnalysisSubjectQuery(subject));

      if (!analysisSubject || analysisSubject.private) {
        return null;
      }

      const queryClient = VennQueryClient.getInstance();
      return queryClient.fetchQuery(createRangeDebugKey(analysisSubject), rangeDebugQueryFn);
    },
});
